import { render, staticRenderFns } from "./TicketsResolutionsSearch.vue?vue&type=template&id=b0293d60&scoped=true&"
import script from "./TicketsResolutionsSearch.vue?vue&type=script&lang=js&"
export * from "./TicketsResolutionsSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0293d60",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
